/* eslint-disable no-loss-of-precision */
import blank from '../../Blank/blankData'

import EyeBigRings from '../../FacialLines/EyeBigRings'
import EyeDimples from '../../FacialLines/EyeDimples'
import EyeLittleRings from '../../FacialLines/EyeLittleRings'

const data = [
  blank,
  {
    id: 'EyeBigRings',
    svg: EyeBigRings,
    positioning: {
      pointNarrow: {
        y: 111.25508117675781,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 111.12178802490234,
        scaleX: 0.85,
      },
      pointWide: {
        y: 106.62872314453125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 113.40118408203125,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 112.89871215820312,
        scaleX: 0.9,
      },
      roundWide: {
        y: 111.58627319335938,
        scaleX: 1,
      },
      squareNarrow: {
        y: 110.07737731933594,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 109.49296569824219,
        scaleX: 0.9,
      },
      squareWide: {
        y: 109.88255310058594,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeDimples',
    svg: EyeDimples,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 100,
        scaleX: 0.85,
      },
      pointWide: {
        y: 101.12301635742188,
        scaleX: 1,
      },
      roundNarrow: {
        y: 105.13429260253906,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 103.14689636230469,
        scaleX: 0.9,
      },
      roundWide: {
        y: 101.88139343261719,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 0.9,
      },
      squareWide: {
        y: 101.74890899658203,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'EyeLittleRings',
    svg: EyeLittleRings,
    positioning: {
      pointNarrow: {
        y: 109.30522155761719,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 112.41989135742188,
        scaleX: 0.8,
      },
      pointWide: {
        y: 109.42196655273438,
        scaleX: 1,
      },
      roundNarrow: {
        y: 114.03652954101562,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 113.25431823730469,
        scaleX: 0.95,
      },
      roundWide: {
        y: 111.55329895019531,
        scaleX: 1,
      },
      squareNarrow: {
        y: 110.376708984375,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 109.71357727050781,
        scaleX: 1,
      },
      squareWide: {
        y: 110.41905212402344,
        scaleX: 1,
      },
    },
  },
]

export default data
